'use client';

import { useTranslation } from '@/hooks/useTranslation';
import type { TransactionItem } from '@/types/core-api';
import { TransactionsList } from '../_shared/TransactionsList';

interface PaymentPlanTransactionsListProps {
  transactions: TransactionItem[];
  currency: string;
  debtNames?: Map<string, string>;
}

export function PaymentPlanTransactionsList({ transactions, currency, debtNames }: PaymentPlanTransactionsListProps) {
  const { t } = useTranslation();

  return (
    <div className="px-4">
      <TransactionsList transactions={transactions} title={t('transaction.transactions')} currency={currency} debtNames={debtNames} />
    </div>
  );
}
